import React, { useState, useEffect,useMemo } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../constants";
import { GetServiceCaller, PostServiceCaller } from "../../../services/serviceCaller";
import { Table, Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import moment from "moment";
import { FaSpinner } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const MyIncreamentComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  useEffect(() => {
    dispatch(updateNavbarHeading("My Increament Components"));
  }, []);

  const [myComponent, setMyComponent] = useState([]);
  const [saving, setSaving] = useState(false);
  const [scaleList, setScaleList] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [employeeName, setEmployeeName] = useState("");
  const [employeeDesignation, setEmployeeDesignation] = useState("");
  const [designationChanged, setDesignationChanged] = useState("");
  const [joinDate, setJoinDate] = useState("");
  const [loading, setLoading] = useState(true); // Add loading state

  const handleGetDataClick = () => {
    if (selectedMonth) {
      fetchMyComponent(selectedMonth);
    } else {
      alert("Please select a month first!");
    }
  };

  const [apiStatus, setApiStatus] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  
  const handleSubmit = async () => {
    setSaving(true);
    try {
        const response = await PostServiceCaller(`${API_URL}appraisal/acknowledged-data`, {}, "post");

        if (response.data.status === 'success' || response.data.success === 'true') {
          toast.success("Acknowledgement completed successfully!");
          navigate("/my-components");
        } else {
            toast.error(response.data.message || "Submit trigger failed.");
        }
    } catch (error) {
        console.error("Submit API Error:", error);
        toast.error("Could not connect to the Submit API.");
    } finally {
        setSaving(false);
    }
  };

  const fetchMyComponent = async (month) => {
    setLoading(true); // Start loading
    setApiStatus(undefined);
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/my-increment-component`
      );
      if (response?.status === 200) {
        setApiStatus(response?.status);
        const data = response?.data?.data?.componentDetails;
        setMyComponent(data);

        const ScaleOptList = Object.entries(
          response?.data?.data?.scale || {}
        ).map(([key, value]) => ({
          value: key,
          label: value,
        }));

        setScaleList(ScaleOptList);
        setSelectedMonth(
          (prevSelected) => prevSelected ?? ScaleOptList[0]?.value
        );

        const name = response?.data?.data?.name;
        setEmployeeName(name);

        const designation = response?.data?.data?.designation;
        setEmployeeDesignation(designation);

        const designationChanged = response?.data?.data?.designationChanged;
        setDesignationChanged(designationChanged);
                
        const doj = response?.data?.data?.doj?.JoiningDate;
        const formattedDate = doj ? moment(doj).format("MMMM D, YYYY") : "";
        setJoinDate(formattedDate);
      } else {
        toast.error(response.data.message);
        navigate("/my-components");
      }
    } catch (error) {
      setApiStatus(400);
      console.error("Error fetching My Components", error);
      toast.error("Failed to fetch data. Please try again.");
    } finally {
      setLoading(false); // Stop loading regardless of success or failure
    }
  };

  useEffect(() => {
    fetchMyComponent();
  }, []);

  const allowedPayrolls = [
    "Basic",
    "HRA",
    "Professional Development Allowance",
    "Other Allowance",
    "Conv Allow",
    "Leave Travel Allowance",
    "NPS",
    "Sales Incentive",
    "Gross Salary",
    "Leave Encashment",
    "Annual Performance Bonus",
    "CCA",
    "Provident Fund",
    "Gratuity",
    "EOS",
    "Mediclaim Insurance",
  ];

  const currentYear = useMemo(() => new Date().getFullYear(), []);
  
  const filteredData = myComponent?.filter((item) =>
    allowedPayrolls.includes(item.Payroll)
  );
  
  let fromDate;
  filteredData?.forEach((item) => {
    fromDate = item.FromDate
      ? moment(item.FromDate).format("MMMM D, YYYY")
      : "";
  });

  const totalAnnualAmount = filteredData?.reduce(
    (sum, item) =>
      item.Payroll !== "Gross Salary" ? sum + parseFloat(item.AnnualAmount || 0) : sum,
    0
  );

  // Full page loader component
  const FullPageLoader = () => (
    <div
      style={{
      position: "absolute", // Changed from fixed
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(255, 255, 255, 0.8)", // Slightly more transparent
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 10, // Lower z-index so it stays under the header
      flexDirection: "column",
      minHeight: "400px" // Ensures visibility if content is empty
    }}
    >
      <div
        className="spinner-border text-primary"
        style={{ width: "4rem", height: "4rem" }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <div className="mt-3 text-primary fw-bold">Loading your appraisal data...</div>
    </div>
  );

  // Show full page loader while loading
  if (loading) {
    return <FullPageLoader />;
  }

  return (
    <>
      <div className="container-fluid py-3" id="skill_section" style={{ backgroundColor: "#f0f2f5", minHeight: "100vh" }}>
        <div
          className="container shadow-lg bg-white p-4 p-md-5 rounded-3"
          id="myComponent"
          style={{ maxWidth: "900px", borderTop: "6px solid #27568b" }}
        >
          {/* Header Section */}
          <div className="mb-4 d-flex justify-content-between align-items-center flex-wrap border-bottom pb-3">
            <div>
              <h3 className="fw-bold mb-0" style={{ color: "#27568b" }}>Appraisal Letter</h3>
              <p className="text-muted mb-0">Confidential</p>
            </div>
            <div className="text-end mt-2 mt-md-0">
              <span className="badge bg-light text-dark border p-2 px-3 rounded-pill">
                Ref Date: {new Date().toLocaleDateString('en-IN')}
              </span>
            </div>
          </div>

          {/* Letter Body */}
          <div className="lh-lg mb-5" style={{ textAlign: "justify", color: "#444" }}>
            <p>Dear <b>{employeeName},</b></p>
            <p>Based on a comprehensive review of your performance, including the achievement of assigned objectives, demonstrated competencies, and overall contribution to the organization, your performance evaluation has been completed.</p>

            <div className="p-3 my-4 rounded-3" style={{ backgroundColor: "#eef2f7", borderLeft: "5px solid #27568b" }}>
              <p className="mb-0">
                {
                    designationChanged ? (
                        <>
                            In recognition of your performance, we are pleased to inform you of your promotion & appraisal. 
                            
                                Your <b>designation</b> has been upgraded to <b>{employeeDesignation}</b> & Your revised <b>CTC</b> is <b>{totalAnnualAmount?.toLocaleString("en-IN", {minimumFractionDigits: 2, maximumFractionDigits: 2,})}</b> INR effective from 1st April 2026 subject to statutory deductions.
                            
                        </>
                    ) : (
                      <>
                          In recognition of your performance, we are pleased to inform you of your appraisal. 
                          Your revised <b>CTC</b> is <b>{totalAnnualAmount?.toLocaleString("en-IN", {minimumFractionDigits: 2, maximumFractionDigits: 2,})}</b> INR effective from 1st April 2026 subject to statutory deductions.
                      </>
                    )
                }
              </p>
            </div>

            <p>The detailed structure of your revised compensation is given as Annexure 1.</p>
            <p>Please note that all other terms and conditions of your employment shall remain unchanged. Also, you will be governed by the Company`s policies as updated from time to time.</p>
            <p>You are encouraged to continue building on your strengths and to focus on further enhancing your capabilities in alignment with organizational goals and expectations.</p>
            <p>We take this opportunity to thank you and your family for the contributions and look forward to your continued association with the organization!</p>
            <p style={{margin:0}}>Sincerely,</p>
            <p style={{margin:0}}><b>For Nice Software Solutions Pvt. Ltd.</b></p>
           
            <br/>
            <p>
            <img src="https://api.nicesoftwaresolutions.com/storage/uploads/profile-img/deep_signature.jpg" style={{ width: "100px", height: "auto" }}/>
            </p>
            <p style={{margin:0}}><b>DEEP SARAF</b></p>
            <p style={{margin:0}}>Managing Director</p>
          </div>

          {/* Employee Banner */}
          <div 
          className="d-flex justify-content-center align-items-center py-2 mb-4 rounded-3 shadow-sm mx-auto px-3" 
          style={{ 
            background: "linear-gradient(135deg, #27568b 0%, #1a3a5f 100%)", 
            color: "white",
            maxWidth: "fit-content",
            fontSize: "0.85rem"
          }}
        >
          <strong className="text-uppercase tracking-wider">Name : {employeeName}</strong>
          <span className="mx-2 opacity-50">|</span>
          <span className="opacity-90">Designation: {employeeDesignation}</span>
          <span className="mx-2 opacity-50">|</span>
          <span className="opacity-90">Effective: {fromDate}</span>
        </div>

          {/* Table Section */}
          {apiStatus === 200 && myComponent.length !== 0 ? (
            <div className="mt-5">
              <h6 className="fw-bold mb-3 text-secondary border-bottom pb-2">Annexure: Compensation Details</h6>
              <div className="table-responsive" style={{textAlign: "justify"}}>
                <Table striped bordered hover>
                  <thead id="thcolor" className="text-center">
                    <tr>
                      <th>EARNINGS</th>
                      <th>PER MONTH</th>
                      <th>Annual Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData?.map((item, index) => (
                      <tr
                        key={index}
                        style={
                          item.Payroll === "Gross Salary"
                            ? { fontWeight: "bold" }
                            : {}
                        }
                      >
                        <td>{item.Payroll}</td>
                        <td className="text-end">
                          {![
                            "Leave Encashment",
                            "Annual Performance Bonus",
                            "Provident Fund",
                            "Gratuity",
                            "Mediclaim Insurance",
                            "EOS",
                          ].includes(item.Payroll)
                            ? parseFloat(item.Amount)?.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : ""}
                        </td>
                        <td className="text-end">
                          {parseFloat(item.AnnualAmount)?.toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </td>
                      </tr>
                    ))}
                    <tr style={{ fontWeight: "bold" }}>
                      <td>Total CTC (INR):</td>
                      <td className="text-end">--</td>
                      <td className="text-end">
                        {totalAnnualAmount?.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>

              {/* ACTION BUTTONS */}
              <div className="d-flex justify-content-center mt-5 mb-4">
                <Button
                  className="btn-lg px-5 shadow-sm border-0"
                  style={{
                    backgroundColor: "#27568b",
                    borderRadius: "50px",
                    fontSize: "1rem",
                    fontWeight: "600",
                    transition: "transform 0.2s"
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                  onClick={() => setShowConfirm(true)}
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <FaSpinner className="spinner-border-sm me-2" />
                      Submitting...
                    </>
                  ) : (
                    "Submit Acknowledgement"
                  )}
                </Button>
              </div>

              {/* Notes Section */}
              <div
                className="text-center text-muted small mt-4 p-3 rounded"
                style={{ backgroundColor: "#f8f9fa", border: "1px dashed #dee2e6" }}
              >
                <i className="bi bi-info-circle me-1"></i>
                This is a system generated document and does not require signature and stamp.
              </div>
            </div>
          ) : (
            !loading && (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )
          )}
        </div>
      </div>
      
      {/* MODAL DIALOGUE */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered size="sm">
        <Modal.Body className="p-4 text-center">
          <h5 className="fw-bold mb-2">Ready to submit?</h5>
          <p className="text-secondary small mb-4">
             I have read, understood and accept my appraisal letter dated 1st April {currentYear} on NEST.
          </p>
          <div className="d-grid gap-2">
            <Button
              style={{ backgroundColor: "#27568b", border: "none" }}
              onClick={() => {
                setShowConfirm(false);
                handleSubmit();
              }}
              disabled={saving}
            >
              {saving ? "Submitting..." : "Yes, Submit Now"}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MyIncreamentComponent;